module.exports = __webpack_public_path__ + "static/media/noclass12.0291368d.png";